import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputDateDirective } from './input-date.directive';



@NgModule({
  declarations: [
    InputDateDirective
  ],
  exports: [
    InputDateDirective
  ],
  imports: [
    CommonModule
  ]
})
export class SharedDirectivesModule { }
